/**
 * Flipnovel 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = brandTheme.primaryGradient || 'linear-gradient(90deg, #FF8A4C 0%, #FF5A36 100%)'

/**
 * Flipnovel 品牌主题配置
 */
export const theme = {
  // 首页背景图（深色模式下不使用背景图）
  homeBg: '',
  // 标签模块背景图
  tagsBg: '',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: brandTheme.primaryColor,
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#262E3A',
  tagInactiveText: '#FF9E7A',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: `linear-gradient(270deg, ${brandTheme.bgGlobal} 0%, ${brandTheme.primaryColor} 95%)`,
  // Tab 激活状态文字颜色
  tabActiveColor: brandTheme.textPrimary,
  // sticky-header 背景
  stickyHeaderBg: brandTheme.bgGlobal,
  primaryGradient,
  tabBorderColor: 'rgba(255, 255, 255, 0.05)',
  tabBackground: 'rgba(255, 255, 255, 0.015)',
  tabTextColor: 'rgba(248, 247, 245, 0.68)',
  tabActiveBorderColor: 'rgba(255, 138, 76, 0.42)',
  tabActiveBackground: 'rgba(255, 138, 76, 0.12)',
  headerIconColor: 'rgba(248, 247, 245, 0.95)',
  isStorlyn: false,
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
